import React, { useState, useEffect } from 'react';
import {
    AppBar,
    Toolbar,
    Box,
    Typography,
    TextField,
    Button,
    IconButton,
  //  ToggleButtonGroup,
  //  ToggleButton
} from '@mui/material';
import { ExitToApp } from '@mui/icons-material';
import { Menu as MenuIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';


const CalendarAppBar: React.FC<{ drawerOpen: boolean, setDrawerOpen: (open: boolean) => void }> = ({ drawerOpen, setDrawerOpen }) => {
    const navigate = useNavigate();
    const [search, setSearch] = useState('');
    const [isFirstImage, setIsFirstImage] = useState(true);
  //  const [view, setView] = useState('week');


    useEffect(() => {
        const interval = setInterval(() => {
            setIsFirstImage((prev) => !prev);
        }, 3000);
        return () => clearInterval(interval);
    }, []);

    return (
        <AppBar
            position="fixed"
            sx={{
                bgcolor: 'white',
                height: '10vh',
                boxShadow: 'none',
                color: 'black',
            }}
        >
            <Toolbar
                sx={{
                    px: 2,
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                }}
            >
                {/* 🔹 Lado izquierdo: Menú + Título */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                        onClick={() => setDrawerOpen(!drawerOpen)}
                        sx={{ mr: 1 }}
                    >
                        <MenuIcon />
                    </IconButton>

                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: 'bold',
                            display: { xs: 'inline', sm: 'block' },
                            fontSize: { xs: '1rem', sm: '1.25rem' },
                        }}
                    >
                        Calendario
                    </Typography>
                </Box>

                {/* 🔹 Centro: Logo */}
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexGrow: 1,
                    }}
                >
                    <Box sx={{ height: 50, position: 'relative' }}>
                        <Box
                            component="img"
                            src="/assets/images/logo-alien4-v2.png"
                            alt="Logo 1"
                            sx={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                height: '100%',
                                width: 'auto',
                                opacity: isFirstImage ? 1 : 0,
                                transition: 'opacity 0.5s ease-in-out',
                            }}
                        />
                        <Box
                            component="img"
                            src="/assets/images/logo-alien-realty.png"
                            alt="Logo 2"
                            sx={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                height: '100%',
                                width: 'auto',
                                opacity: isFirstImage ? 0 : 1,
                                transition: 'opacity 0.5s ease-in-out',
                            }}
                        />
                    </Box>
                </Box>

                {/* 🔹 Lado derecho: Buscador (solo en SM+) y botón salir */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {/* 🔍 Buscador solo en pantallas medianas o más */}
                    <TextField
                        size="small"
                        variant="outlined"
                        placeholder="Buscar..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        sx={{
                            display: { xs: 'none', sm: 'block' },
                            width: 200,
                        }}
                    />

                    {/* 🚪 Botón salir: icono en XS, texto en SM+ */}
                    <IconButton
                        onClick={() => navigate(-1)}
                        sx={{
                            display: { xs: 'flex', sm: 'none' },
                        }}
                        color="inherit"
                    >
                        <ExitToApp fontSize="small" />
                    </IconButton>

                    <Button
                        variant="outlined"
                        color="inherit"
                        startIcon={<ExitToApp />}
                        onClick={() => navigate(-1)}
                        sx={{
                            display: { xs: 'none', sm: 'inline-flex' },
                        }}
                    >
                        Salir
                    </Button>
                </Box>
            </Toolbar>
        </AppBar>
    );
};

export default CalendarAppBar;
